import { render, staticRenderFns } from "./juryOptionsViewer.vue?vue&type=template&id=6bec1409&scoped=true"
import script from "./juryOptionsViewer.vue?vue&type=script&lang=js"
export * from "./juryOptionsViewer.vue?vue&type=script&lang=js"
import style0 from "./juryOptionsViewer.vue?vue&type=style&index=0&id=6bec1409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec1409",
  null
  
)

/* custom blocks */
import block0 from "./juryOptionsViewer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports